var $ = (m, V, a) => new Promise((v, r) => {
  var i = (l) => {
    try {
      u(a.next(l));
    } catch (s) {
      r(s);
    }
  }, c = (l) => {
    try {
      u(a.throw(l));
    } catch (s) {
      r(s);
    }
  }, u = (l) => l.done ? v(l.value) : Promise.resolve(l.value).then(i, c);
  u((a = a.apply(m, V)).next());
});
import "../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { listOptionsByAttribute as q } from "../../../request/bsplatform/external/commodity/listOptionsByAttribute/post.js";
import N from "./inputTypeItem/index.vue.js";
import { useLoadingBar as D } from "../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/loading-bar/src/use-loading-bar.js";
import { defineComponent as j, computed as o, onMounted as H, watch as b, openBlock as w, createElementBlock as U, createBlock as x, createCommentVNode as M, createVNode as z, Fragment as L } from "../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as B, unref as T } from "../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import A from "../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
const Y = /* @__PURE__ */ j({
  __name: "EditTextAttr.ce",
  props: {
    modelValue: {
      type: String,
      required: !1,
      default: ""
    },
    code: {
      type: String,
      required: !1,
      default: ""
    },
    inventory: {
      type: Object,
      required: !0
    },
    item: {
      type: Object,
      required: !0
    },
    classify3: {
      type: String,
      required: !0
    },
    classify4: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    fromCaxa: {
      type: Boolean,
      default: !1
    },
    classify1: {
      type: String,
      required: !0
    },
    isEditRemark: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "error"],
  setup(m, { emit: V }) {
    const a = m, v = D(), r = B(/* @__PURE__ */ new Map()), i = B(/* @__PURE__ */ new Map()), c = o(() => {
      const e = a.fromCaxa || "", t = !!(a.classify1 && a.classify1 === "智纳百货类"), n = a.isEditRemark || !1;
      return !!(e && t && n);
    }), u = o(() => {
      const t = (a.modelValue || "").match(/【(.*?)】/g);
      return t && t[0] ? t[0].slice(1, -1) : "";
    }), l = o(() => {
      const t = (a.modelValue || "").match(/【(.*?)】/g);
      return t && t[1] ? t[1].slice(1, -1) : "";
    }), s = o(() => {
      const e = a.modelValue || "", t = e.lastIndexOf("】");
      let d = (a.modelValue || "").replace(/【\S*】/g, "");
      p("error", a.code, f.value && !k.value && !d);
      const y = i.value.get(l.value);
      return y && y.inputType === "CHECKBOX" ? (d ? d.split("，") : []).join(",") : t !== -1 ? e.slice(t + 1).trim() : "";
    }), S = o(() => Array.from(r.value.keys()).map((e) => ({
      label: e,
      value: e
    }))), C = o(() => Array.from(i.value.keys()).map((e) => ({
      label: e,
      value: e
    }))), f = o(() => ["MATERIALS", "STANDARD"].includes("STANDARD") && a.item.attributeCode === "editRemark" && r.value.size > 0), k = o(() => {
      const e = i.value.get(l.value);
      return !(e && e.customized);
    }), I = () => {
      const e = i.value.get(l.value);
      return e && "inputType" in e ? {
        inputType: e.inputType || "",
        // 提供默认值
        options: e.options || []
        // 提供默认值
      } : { inputType: "", options: [] };
    }, g = (e) => (i.value = new Map((r.value.get(e) || []).map((t) => [t.name, t])), !0), h = o(() => ({
      attributeCode: a.item.attributeCode,
      classify3: a.classify3,
      classify4: a.classify4,
      marketClassifies: a.inventory.baseInfo.marketClassify ? a.inventory.baseInfo.marketClassify.split(",") : []
    }));
    H(() => $(this, null, function* () {
      if (h.value) {
        v.start();
        const { data: e = [] } = yield q(h.value);
        v.finish(), r.value = new Map(
          e.map(({ code: t, items: n }) => [t, n || []])
        );
      }
      u.value && g(u.value);
    }));
    const R = (e) => {
      const t = `【${e}】${l.value ? `【${l.value}】` : ""}${s.value}`;
      p("update:modelValue", t);
    }, E = (e) => {
      const t = `${u.value ? `【${u.value}】` : ""}【${e}】`;
      p("update:modelValue", t);
    }, O = (e) => {
      const t = `${u.value ? `【${u.value}】` : ""}${l.value ? `【${l.value}】` : ""}${e}`;
      p("update:modelValue", t);
    };
    b(
      () => u.value,
      (e, t) => {
        var n;
        if (e !== t) {
          g(e);
          const d = ((n = C.value[0]) == null ? void 0 : n.value) || "", y = `【${e}】${d ? `【${d}】` : ""}`;
          p("update:modelValue", y);
        }
      }
    ), b(
      () => l.value,
      (e) => {
        if (e) {
          const t = `${u.value ? `【${u.value}】` : ""}【${e}】${s.value}`;
          p("update:modelValue", t);
        }
      }
    ), b(
      () => a.modelValue,
      (e) => $(this, null, function* () {
        e && g(u.value);
      }),
      { immediate: !0 }
      // 立即执行一次监听回调
    );
    const p = V;
    return (e, t) => (w(), U(L, null, [
      f.value ? (w(), x(T(A), {
        key: 0,
        value: u.value,
        disabled: c.value,
        options: S.value,
        class: "tw:!w-[160px] tw:mr-2",
        "onUpdate:value": R
      }, null, 8, ["value", "disabled", "options"])) : M("", !0),
      f.value ? (w(), x(T(A), {
        key: 1,
        value: l.value,
        options: C.value,
        disabled: !u.value || c.value,
        class: "tw:!w-[160px] tw:mr-2",
        "onUpdate:value": E
      }, null, 8, ["value", "options", "disabled"])) : M("", !0),
      z(N, {
        class: "tw:!w-[160px]",
        item: I(),
        modelValue: s.value,
        "onUpdate:modelValue": t[0] || (t[0] = (n) => s.value = n),
        disabled: !!(m.disabled || f.value && k.value) || c.value,
        onChangeHandleInput: O
      }, null, 8, ["item", "modelValue", "disabled"])
    ], 64));
  }
});
export {
  Y as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/EditTextAttr.ce.vue2.js
// module id = 1190
// module chunks = 41